import { Box } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { SortingTypeI } from "../../../Utils/consts";
import {
  buildTrackingPayload,
  initialTrackingSearch,
  trackingSortById,
} from "./helpers";
import { useBarcodeTracking } from "./hooks";
import TrackingTable from "./TrackingTable";
import { TrackingMode } from "./types";
// import { useOncologyFacilitiesLookup } from "Pages/SupplyManagement/ManageOrderOncology/hooks";
import CustomPagination from "Shared/JsxPagination";
import usePagination from "Shared/hooks/usePagination";
import useLang from "Shared/hooks/useLanguage";

function TrackingList({ mode }: { mode: TrackingMode }) {
  const { t } = useLang();
  const [searchRequest, setSearchRequest] = useState(initialTrackingSearch);
  const [appliedSearch, setAppliedSearch] = useState(initialTrackingSearch);
  const [sort, setSorting] = useState<SortingTypeI>(trackingSortById);

  const {
    curPage,
    pageSize,
    total,
    totalPages,
    pageNumbers,
    nextPage,
    prevPage,
    showPage,
    setPageSize,
    setTotal,
    setCurPage,
  } = usePagination();

  // const { data: facilities = [] } = useOncologyFacilitiesLookup();

  const trackingPayload = useMemo(
    () =>
      buildTrackingPayload({
        mode,
        pageNumber: curPage,
        pageSize,
        search: appliedSearch,
        sort,
      }),
    [appliedSearch, curPage, mode, pageSize, sort]
  );

  const {
    data: trackingResult,
    isLoading,
    isFetching,
  } = useBarcodeTracking(trackingPayload);

  const rows = trackingResult?.rows ?? [];
  const loading = isLoading || (isFetching && rows.length === 0);

  useEffect(() => {
    setTotal(trackingResult?.total ?? 0);
  }, [setTotal, trackingResult?.total]);

  useEffect(() => {
    setSearchRequest(initialTrackingSearch);
    setAppliedSearch(initialTrackingSearch);
    setSorting(trackingSortById);
    setCurPage(1);
  }, [mode, setCurPage]);

  useEffect(() => {
    setCurPage(1);
  }, [pageSize, setCurPage]);

  // const applySearch = () => {
  //   setCurPage(1);
  //   setAppliedSearch(searchRequest);
  // };

  const resetSearch = () => {
    setSearchRequest(initialTrackingSearch);
    setAppliedSearch(initialTrackingSearch);
    setSorting(trackingSortById);
    setCurPage(1);
  };

  const handleSort = (columnName: string) => {
    setSorting((prev) => ({
      clickedIconData: columnName,
      sortingOrder:
        prev.clickedIconData === columnName && prev.sortingOrder === "asc"
          ? "desc"
          : "asc",
    }));
  };

  return (
    <>
      <div className="mb-2 d-flex flex-wrap gap-2 justify-content-center justify-content-md-between align-items-center">
        <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center">
          <div className="d-flex align-items-center">
            <span className="fw-400 mr-3">{t("Records:")}</span>
            <select
              id={`SupplyTracking${mode}Records`}
              className="form-select w-125px h-33px rounded py-2"
              onChange={(e) => setPageSize(parseInt(e.target.value, 10))}
              value={pageSize}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2 gap-lg-3">
          {/* <div className="min-w-225px">
            <Select
              inputId={`SupplyTracking${mode}Facility`}
              menuPortalTarget={document.body}
              styles={reactSelectSMStyle}
              options={facilities}
              theme={(theme: any) => styles(theme)}
              placeholder={t("Facility")}
              isClearable
              value={facilities.filter(
                (item) =>
                  Number(item.value) === Number(searchRequest.facilityId)
              )}
              onChange={(event: any) =>
                setSearchRequest({
                  facilityId: event?.value ?? 0,
                })
              }
            />
          </div> */}
          {/* <button
            id={`SupplyTracking${mode}Search`}
            onClick={applySearch}
            className="btn btn-linkedin btn-sm fw-500"
          >
            {t("Search")}
          </button> */}
          <button
            id={`SupplyTracking${mode}Reset`}
            onClick={resetSearch}
            type="button"
            className="btn btn-secondary btn-sm btn-secondary--icon fw-500"
          >
            <span>
              <span>{t("Reset")}</span>
            </span>
          </button>
        </div>
      </div>

      <div className="card">
        <Box sx={{ height: "auto", width: "100%" }}>
          <TrackingTable
            loading={loading}
            mode={mode}
            rows={rows}
            sort={sort}
            onSort={handleSort}
          />
          <CustomPagination
            curPage={curPage}
            nextPage={nextPage}
            pageNumbers={pageNumbers}
            pageSize={pageSize}
            prevPage={prevPage}
            showPage={showPage}
            total={total}
            totalPages={totalPages}
          />
        </Box>
      </div>
    </>
  );
}

export default TrackingList;
